// extracted by mini-css-extract-plugin
module.exports = {"qualificationInput":"SingleAuthorForm_qualificationInput_14mKc","spinAround":"SingleAuthorForm_spinAround_1mjdR"};